import { Check } from "lucide-react";

// One tile for every insurer surface: CarSavr draws the rounded "app" icon,
// the insurer's own logo file sits inside it untouched (object-contain, no crop).
// state: "resting" (grey) | "color" (brand colour, no emphasis) | "active" (brand colour) | "complete" (colour + tick)
const SIZES = {
  md: { fig: "w-full", box: "w-full max-w-[76px] sm:max-w-[88px] aspect-square rounded-[16px]", label: "text-[11px]" },
  rail: { fig: "", box: "w-[68px] h-[68px] sm:w-[76px] sm:h-[76px] rounded-[16px]", label: "text-[11px]" },
  sm: { fig: "", box: "w-14 h-14 rounded-xl", label: "text-[10px]" },
};
// Logo bounds inside the icon, by artwork shape (see VERIFIED_INSURERS.fit).
const FIT = { standard: "w-[78%] h-[78%]", wide: "w-[90%] h-[60%]" };

export const ProviderAppTile = ({ insurer, state = "resting", size = "md", showLabel = true, labelClass = "text-slate-600", decorative = false, focusable = false, eager = false }) => {
  const s = SIZES[size];
  const lit = state !== "resting";
  return (
    <figure tabIndex={focusable ? 0 : undefined} className={`provider-tile group flex flex-col items-center gap-1.5 m-0 shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-[#10B981] focus-visible:ring-offset-2 focus-visible:ring-offset-transparent rounded-xl ${s.fig}`} data-state={state} data-testid={decorative ? undefined : `provider-tile-${insurer.slug}`}>
      <div
        className={`relative ${s.box} bg-white border flex items-center justify-center transition-[border-color,box-shadow,transform] duration-200 ease-out ${
          state === "active" ? "border-[#0A2540]/40 shadow-cardHover -translate-y-0.5" : "border-slate-200/80 shadow-card"
        } group-hover:-translate-y-0.5 group-hover:shadow-cardHover`}
      >
        <img
          src={insurer.src}
          alt={decorative ? "" : `${insurer.name} logo`}
          width="64"
          height="64"
          loading={eager ? "eager" : "lazy"}
          decoding="async"
          draggable="false"
          className={`provider-tile-logo ${FIT[insurer.fit] || FIT.standard} object-contain transition-[filter,opacity] duration-200 ${lit ? "" : "grayscale opacity-[0.82]"}`}
        />
        {state === "complete" && (
          <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-[#10B981] text-[#0A2540] flex items-center justify-center ring-2 ring-white">
            <Check className="w-3 h-3" strokeWidth={3} aria-hidden="true" />
            <span className="sr-only">compared in this example</span>
          </span>
        )}
      </div>
      {showLabel && <figcaption className={`${s.label} font-medium leading-tight text-center ${labelClass}`}>{insurer.name}</figcaption>}
    </figure>
  );
};

export default ProviderAppTile;
